"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormRichSelect", {
    enumerable: true,
    get: function() {
        return FormRichSelect;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _reactdom = require("@floating-ui/react-dom");
const _FormRichSelectContext = require("./FormRichSelectContext");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormRichSelect = (param)=>{
    let { onOpen, onClose, children, disabled = false } = param;
    const [open, setOpen] = (0, _react.useState)(false);
    const floating = (0, _reactdom.useFloating)({
        placement: "bottom-start",
        middleware: [
            (0, _reactdom.shift)(),
            (0, _reactdom.flip)(),
            (0, _reactdom.size)({
                apply (param) {
                    let { availableWidth } = param;
                    if (floating.refs.floating.current != null) {
                        floating.refs.floating.current.style.width = "".concat(availableWidth, "px");
                    }
                }
            })
        ]
    });
    (0, _react.useEffect)(()=>{
        if (open) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        } else {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [
        open,
        onOpen,
        onClose
    ]);
    (0, _react.useEffect)(()=>{
        var _floating_refs_floating_current;
        const onClick = (e)=>{
            var _f_refs_reference_current, _f_refs_floating_current;
            const target = e.target;
            const f = floating;
            if (f.refs.reference.current !== target && ((_f_refs_reference_current = f.refs.reference.current) === null || _f_refs_reference_current === void 0 ? void 0 : _f_refs_reference_current.contains(target)) === false && ((_f_refs_floating_current = f.refs.floating.current) === null || _f_refs_floating_current === void 0 ? void 0 : _f_refs_floating_current.contains(target)) === false) {
                setOpen(false);
            }
        };
        const onKeyup = (e)=>{
            if (e.key === "Escape") {
                e.stopImmediatePropagation();
                e.preventDefault();
                setOpen(false);
            }
        };
        (_floating_refs_floating_current = floating.refs.floating.current) === null || _floating_refs_floating_current === void 0 ? void 0 : _floating_refs_floating_current.addEventListener("keyup", onKeyup);
        return ()=>{
            var _floating_refs_floating_current;
            window.removeEventListener("click", onClick);
            (_floating_refs_floating_current = floating.refs.floating.current) === null || _floating_refs_floating_current === void 0 ? void 0 : _floating_refs_floating_current.removeEventListener("keyup", onKeyup);
        };
    }, [
        floating
    ]);
    return /*#__PURE__*/ _react.default.createElement(_FormRichSelectContext.FormRichSelectContext.Provider, {
        value: {
            setOpen: (s)=>{
                setOpen(s);
                floating.update();
            },
            open,
            disabled,
            ...floating
        }
    }, children);
};

//# sourceMappingURL=FormRichSelect.js.map